import React, { Component } from 'react'
import girl from "../assets/images/girl.png";
// import Slide from "./Content/PurposeOfUse";

// import QueueAnim from 'rc-queue-anim';
// import TransitionManager from 'react-transition-manager';

import PurposeOfUse from './Content/PurposeOfUse';
import Disclaimer from './Content/Disclaimer';
import Start from './Content/Start';
import Range from './Content/Range';
import Nystagmus from "./Content/Nystagmus";
import EVSTriggerRandom from "./Content/EVSTriggerRandom";
import TriggerTestStart from "./Content/TriggerTestStart";
import MotionSickness from "./Content/MotionSickness";
import Standing from "./Content/Standing";
import TestDix from "./Content/TestDix";
import TestSupine from "./Content/TestSupine";
import SEVS from "./Content/SEVS";
import HeadImpulseTest from "./Content/HeadImpulseTest";
import SkewHit from "./Content/SkewHit";
import OtherPotentialCauses from "./Content/OtherPotentialCauses";

export default class Board extends Component {
    
   
    
   
    renderSlide = () => {

        const {onClick, slide} = this.props;
        switch(slide){

            case 2:
                return <Disclaimer onClick={onClick}/>

            case 3:
                return <Start onClick={onClick}/>
            
            case 4:
                return <Range onClick={onClick}/>

            case 5:
                return <Nystagmus onClick={onClick}/>
            
            case 6:
                return <EVSTriggerRandom onClick={onClick}/>
            
            case 7:
                return <TriggerTestStart onClick={onClick}/>
            
            case 8:
                return <MotionSickness onClick={onClick}/>

            case 9:
                return <Standing onClick={onClick}/>
            
            case 10:
                return <TestDix onClick={onClick}/>

            case 11:
                return <TestSupine onClick={onClick}/>
            
            case 12:
                return <SEVS onClick={onClick}/>
            
            case 15:
                return <HeadImpulseTest onClick={onClick}/>
            
            case 16:
                return <SkewHit onClick={onClick}/>
            
            case 25:
                return <OtherPotentialCauses onClick={onClick}/>

            default:
            case 1:
                return <PurposeOfUse onClick={onClick}/>;
        }
    }
    
    render() {

        const {onBack,slide} = this.props;
    
    return (
        <section id="banner-part">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="banner_topic">
                            <div className="board">
                                <div  className="banner_write">
                                    { slide !== 1 && <div className="link">
                                        {/* eslint-disable-next-line */}
                                        <a href="#" onClick={onBack}><i className="fas fa-arrow-left"></i> Go Back</a>
                                    </div>}

                                    <div className="p-30">
                                         {this.renderSlide() }
                                    </div>
                                    <div key="5" className="girl d-none d-lg-block">
                                        <img src={girl} alt="grl"/>
                                    </div>
                                </div>
                            </div>


                            
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
  }
}
